import LatLongField from './LatLongField';

export default LatLongField;
